import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

export const LegalPage = ({ doc, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const prev = document.title;
    document.title = `${doc.title} – REVIVO-Smartpool by coolpool`;
    return () => { document.title = prev; };
  }, [doc]);

  return (
    <div data-testid={testId}>
      <header className="border-b border-white/10 py-5">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 sm:px-8">
          <Logo href="/" />
          <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm text-[var(--mist)] hover:text-[var(--foam)] transition-colors">
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-20 sm:px-8 sm:py-28">
        <h1 data-testid="legal-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] break-words [hyphens:auto]">{doc.title}</h1>
        <div className="mt-14 space-y-10">
          {doc.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-xl sm:text-2xl font-medium tracking-[-0.01em] text-[var(--foam)]">{s.h}</h2>
              {s.p.map((t) => (
                <p key={t} className="mt-3 whitespace-pre-line text-sm sm:text-base leading-relaxed text-[var(--mist)]">{t}</p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer compact />
    </div>
  );
};
